
export const ClsApi = 'wx/cls/' // 类别
export const VipApi = 'wx/vipinfo/' // 会员信息
export const ProductApi = 'wx/shopmarketproduct/' // 显示店铺发布的商品
export const FavProductApi = 'wx/shopmarketfavproduct/' // 会员收藏夹
export const CartApi = 'wx/shopmarketcart/' // 购物车信息
export const OrderApi = 'wx/shopmarketorder/' // 客户订单
export const OrderProductApi = 'wx/shopmarketorderproduct/' // 客户订单的明细信息
export const OrderItemApi = "wx/shopmarketorderitem/" // 订单表身特殊查询
export const AddressApi = 'wx/shopmarketaddress/' // 发货地址
export const CurShopInfoApi = 'wx/curshopinfo/' // 微信店铺的联系信息
export const UserCarApi = 'wx/usercar/' // 会员爱车
export const AssertApi = 'wx/assert/' // 会员的资产，包含储值卡、优惠券、兑换券
export const AssertDetailApi = 'wx/assertdetail/' // 会员的资产，包含储值卡、优惠券、兑换券
export const getUserInfoApi = 'wx/get_user_info/' // 获得用户信息
export const UnifiedDirectSellOrderApi = 'wx/unifieddirectsellorder/' // 直销微信支付
export const UnifiedShopMarketOrderApi = 'wx/unifiedshopmarketorder/' // 商城订单微信支付

